module.exports = __webpack_public_path__ + "img/direccion-o-d.6a45f62e.png";